import { __ } from '@wordpress/i18n';
import { __experimentalToolsPanelItem as ToolsPanelItem,	ToggleControl, SelectControl } from '@wordpress/components';

export function ResponsiveToggleControl({ label, attribute, breakpoint = 'default', optionsState, help = null, checkedMap, onChangeMap }) {
	const { get, getResolved, set, has, reset } = optionsState;
	const isDefault = breakpoint === 'default';
	const value = get(attribute, breakpoint);
	const isInherited = !isDefault && value === undefined;

	// Show the cascaded (resolved) value so inherited state is visually accurate
	const resolvedValue = isDefault ? value : getResolved(attribute, breakpoint);
	const isChecked = checkedMap ? checkedMap( resolvedValue ) : !!resolvedValue;

	return (
		<ToolsPanelItem
			label={label}
			hasValue={() => has(attribute, breakpoint)}
			onDeselect={() => reset(attribute, breakpoint)}
			isShownByDefault
		>
			<ToggleControl
				label={label}
				checked={isChecked}
				onChange={(val) => set(attribute, breakpoint, onChangeMap ? onChangeMap( val ) : val)}
				help={
					help || (
						isInherited
							? __('Inherit', 'groundworx-carousel')
							: isChecked
								? __('Enabled', 'groundworx-carousel')
								: __('Disabled', 'groundworx-carousel')
					)
				}
				className={isInherited ? 'is-inherited' : ''}
				__nextHasNoMarginBottom
			/>
		</ToolsPanelItem>
	);
}

export function ResponsiveSelectControl({ label, attribute, breakpoint = 'default', optionsState, options = [], showInherit = true }) {
	const { get, set, has, reset } = optionsState;
	const isDefault = breakpoint === 'default';
	const value = get(attribute, breakpoint);

	const selectOptions = [
		...(isDefault || !showInherit ? [] : [{ label: __('Inherit', 'groundworx-carousel'), value: '' }]),
		...options
	];

	return (
		<ToolsPanelItem
			label={label}
			hasValue={() => has(attribute, breakpoint)}
			onDeselect={() => reset(attribute, breakpoint)}
			isShownByDefault
		>
			<SelectControl
				label={label}
				value={value || ''}
				onChange={(val) => set(attribute, breakpoint, val || undefined)}
				options={selectOptions}
			/>
		</ToolsPanelItem>
	);
}

export function ResponsiveRangeControl({ label, attribute, breakpoint = 'default', optionsState, ControlComponent, ...controlProps }) {
	const { get, set, has, reset } = optionsState;
	const value = get(attribute, breakpoint);

	return (
		<ToolsPanelItem
			label={label}
			hasValue={() => has(attribute, breakpoint)}
			onDeselect={() => reset(attribute, breakpoint)}
			isShownByDefault
		>
			<ControlComponent
				label={label}
				value={value}
				onChange={(val) => set(attribute, breakpoint, val)}
				{...controlProps}
			/>
		</ToolsPanelItem>
	);
}

export function ResponsiveMultiControl({ label, attributes, breakpoint = 'default', optionsState, ControlComponent, onDeselect, ...controlProps }) {
	const { has } = optionsState;

	return (
		<ToolsPanelItem
			label={label}
			hasValue={() => attributes.some(attr => has(attr, breakpoint))}
			onDeselect={onDeselect}
			isShownByDefault
		>
			<ControlComponent
				{...controlProps}
			/>
		</ToolsPanelItem>
	);
}
